import { createSelector } from '@ngrx/store';
import { ingredientsState } from '../root';

export const getIngredientsByLocationNo = (locationNo: number) => createSelector(ingredientsState, (ingredients) => ingredients.filter((obj) => obj.LocationNo === locationNo));
